import React, { useState } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import StreamCard from "../../components/organisms/StreamCard/StreamCard";
import { useStreamContext } from "../../contexts/StreamContext";

const AllStreamsSection = () => {
    const { orderedStreams } = useStreamContext();
    const [searchQuery, setSearchQuery] = useState("");

    // Function to modify the featured image URL
    // const modifyFeaturedImageUrl = (imageUrl) => {
    //     const baseUrl = "https://churchcamlive.ie";
    //     const cdnUrl = "https://assets.churchcamlive.ie";
    //     const sizeString = "768x432";
    //     const updatedUrl = imageUrl.replace(baseUrl, cdnUrl);

    //     // Extract the file extension
    //     const lastDotIndex = updatedUrl.lastIndexOf(".");
    //     if (lastDotIndex === -1) return updatedUrl; // No extension found

    //     const extension = updatedUrl.substring(lastDotIndex);
    //     const urlWithoutExtension = updatedUrl.substring(0, lastDotIndex);

    //     // Insert the size string before the extension
    //     const modifiedUrl = `${urlWithoutExtension}-${sizeString}${extension}`;

    //     return modifiedUrl;
    // };

    const buildFeaturedImageUrl = (slug, featuredImageUrl) => {
        const baseUrl = "https://churchcamlive.ie";
        const sizeString = "768x432";
        const imageUrl = `/assets/images/background-images/${slug}`;
        const lastDotIndex = featuredImageUrl.lastIndexOf(".");
        const extension = featuredImageUrl.substring(lastDotIndex);

        return `${baseUrl}${imageUrl}-${sizeString}${extension}`;
    }

    // Filter streams based on search query
    const normalizeText = (text) =>
        text
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/['’]/g, "")
            .toLowerCase();

    const filteredStreams = orderedStreams.filter((stream) =>
        normalizeText(stream.title.rendered).includes(
            normalizeText(searchQuery)
        )
    );

    return (
        <Container className="py-5" id="all-streams-section">
            <div className="container d-flex justify-content-center flex-row my-4">
                <Row>
                    <Col className="d-flex justify-content-center flex-row">
                        <Form.Control
                            style={{ background: "#f2f2f2" }}
                            size="lg"
                            type="text"
                            placeholder="Search streams..."
                            className="rounded-0 border-0"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <Button
                            type="submit"
                            className="ccl-btn-blue rounded-0"
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </div>
            <div className="container">
                <Row xs={1} sm={2} lg={3} className="g-2 stream-card-container">
                    {filteredStreams.map((stream) => {
                        const featuredMediaUrl = stream.featured_media;

                        return (
                            <Col key={stream.id}>
                                <Link
                                    to={`/${stream.slug}`}
                                    className="text-decoration-none"
                                    aria-label={`Click here to go to the ${stream.title.rendered} Live Stream Page`}
                                >
                                    <StreamCard
                                        title={stream.title.rendered}
                                        featuredImageUrl={

                                                buildFeaturedImageUrl(
                                                      stream.slug, featuredMediaUrl
                                                  )

                                        }
                                    />
                                </Link>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </Container>
    );
};

export default AllStreamsSection;
